const obj = {
  /**
   * 美礼卡 34
   */
  //  删除上传图片
  cancelOneImage: "base/file/mgmt/cancelOneImage",
  //  卡介质/卡标签/经营类型
  getGiftCardInfo: "/giftcard/label/all",
  //  美礼卡店铺列表
  getStoreInfoList: "/merchant/storeInfo/getStoreInfoList",
  //  提交审核
  addGiftCardInfo: "/giftcard/batch/commitAudit",
  //  保存
  saveDraft: "/giftcard/batch/saveDraft",
  //  轮播图
  getGiftCollocateDetail: "/giftcard/carousel/query",
  //  保存轮播
  addGiftCardCollocateInfo: "/giftcard/carousel/edit",
  //  美礼卡订单
  getOrderOfPage: "/giftcard/order/query",
  //  美礼卡订单详情
  getOrderByOrderId: "/giftcard/order/detail",
  //  美礼卡标签
  getGiftCardLabelList: "/giftcard/label/query",
  //  美礼卡标签添加
  addGiftCardLabel: "/giftcard/label/add",
  //  编辑美礼卡
  editGiftCardLabelById: "/giftcard/label/edit",
  //  删除美礼卡标签
  cancelGiftCardLabel: "/giftcard/label/delete",
  // 发行列表
  query: "/giftcard/batch/query",
  //  删除列表
  cardDelete: "/giftcard/batch/delete/",
  //  编辑列表
  cardDetail: "/giftcard/batch/detail",
  //  编辑提交
  cardEdit: "/giftcard/batch/edit",
  //  编辑店铺列表
  getStoreLists: "/merchant/storeInfo/getStoreLists",
  //  编辑商品列表
  findGoodsList: "/goods/item/findGoodsList",
  //  更改优先级
  updPriority: "/giftcard/batch/updatePriority",
  //  上架/下架
  handle: "/giftcard/batch/handle",
  //  生产
  produce: "/giftcard/batch/produce",
  //  卡密
  export: "/giftcard/batch/export",
  //  礼卡管理
  cardsmanage: "/giftcard/unit/query",
  //  礼卡管理详情
  unitDetail: "/giftcard/unit/detail",
  //  消费记录
  consumeLog: "/giftcard/unit/consumeLog",
  //  冻结
  freeze: "/giftcard/unit/batchFreeze",
  //  解冻
  unfreeze: "/giftcard/unit/unfreeze",
  //  激活
  active: "/giftcard/unit/batchActive",
  //  续期
  renewal: "/giftcard/unit/renew",
  //  轮播信息
  sliderInfo: "/giftcard/carousel/detail",
  //  精选列表
  cardSelect: "/giftcard/select/query",
  //  删除精选
  choiceDelete: "/giftcard/select/delete",
  //  精选上移
  moveUp: "/giftcard/select/moveUp",
  //  精选下移
  moveDown: "/giftcard/select/moveDown",
  //  添加精选
  addSelect: "/giftcard/select/add",
  //  卡号区间
  numRange: "/giftcard/batch/span",
  //  订单导出
  exportList: "/giftcard/order/export",
  //  作废礼卡
  scrap: "/giftcard/unit/scrap",
  //  已选店铺列表
  getSelectedStoreList: "/giftcard/platform/range/getSelectedStoreList/",
  //  已选商品列表
  getSelectedItemList: "/giftcard/platform/range/getSelectedItemList/",
  //  上移
  moveUpwardLable: "/giftcard/label/moveUpward/",
  //  下移
  moveDownLable: "/giftcard/label/moveDown/",
  // 获取优惠券列表
  getCouponList:'/giftcard/platform/range/getCouponList',
  // 回显已经选择的优惠券
  showGiftPrize:'giftcard/platform/range/showGiftPrize/',

}
export default obj;
